import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import LinearProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/LinearProgress';
import Typography from 'Components/UI/Typography';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: theme.dimensions.md,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  text: {
    paddingBottom: theme.spacing(0.5),
  },
  slider: {
    width: '100%',
  },
});

const FlowProgress = ({
  className,
  classes,
  currentStep,
  totalSteps,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.text}
        color="seafoam"
        variant="h5"
      >
        {`${currentStep} of ${totalSteps}`}
      </Typography>
      <LinearProgress
        className={classes.slider}
        color="seafoam"
        value={100 * currentStep / totalSteps}
        variant="determinate"
      />
    </div>
  );
};

FlowProgress.defaultProps = {
  className: '',
};

FlowProgress.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default withStyles(styles)(FlowProgress);
